import { render, staticRenderFns } from "./HelpSideBar.vue?vue&type=template&id=28b91e84"
import script from "./HelpSideBar.vue?vue&type=script&lang=js"
export * from "./HelpSideBar.vue?vue&type=script&lang=js"
import style0 from "./HelpSideBar.vue?vue&type=style&index=0&id=28b91e84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports